<script setup lang="ts">
  import {
    FormFieldContainer,
    InputField,
    SwitchButton,
    type CheckboxField,
  } from '@logistiek-zonder-papier/lzp-library'
  import FlowPathInput from '@/components/form/FlowPathInput.vue'

  const field = defineModel<CheckboxField>({ required: true })
</script>

<template>
  <div class="field-config-container">
    <FormFieldContainer label="Label als html (PAS OP DIT KAN GEVAARLIJK ZIJN!)">
      <SwitchButton v-model="field.labelIsHtml" />
    </FormFieldContainer>

    <FormFieldContainer label="Label">
      <FlowPathInput
        placeholder="Field label"
        hint="Shown above the field. Supports ${...} interpolation."
        v-model="field.label"
        :optional="true"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Store Location">
      <InputField
        placeholder="x.path.to.location"
        hint="Target path url."
        v-model="field.storeLocation"
        type="text"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Required to be true">
      <SwitchButton v-model="field.requiredTrue" />
    </FormFieldContainer>

    <FormFieldContainer label="Error message">
      <FlowPathInput
        placeholder="Error message under the field"
        v-model="field.error"
        :optional="true"
        :validate-paths="true"
      />
    </FormFieldContainer>
  </div>
</template>

<style scoped>
  .field-config-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
</style>
